"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlaceholderItems = (placeholderCount) => {
    return Array.from({ length: placeholderCount }).map(() => ({
        isPlaceholder: true,
    }));
};
//# sourceMappingURL=getPlaceholderItems.js.map